core.constant('roleMeedyTranslationPL', {
  "T": {
    "MEEDY": {
      "SYSTEM": {
        "MESSAGE": {
          "DELETE_ALL_ROLES_CONFIRMATION": "Czy na pewno chcesz usunąć role: ",
          "DELETE_ROLE_CONFIRMATION": "Czy na pewno chcesz usunąć rolę"
        }
      },
      "UI": {
        "TABBAR": {
          "ROLE": {
            "ROLE": "Rola"
          }
        },
        "BREADCRUMB": {
          "ROLE": {
            "ROLE": "Rola",
            "ROLES": "Role",
            "CREATE": "Dodaj rolę",
            "EDIT": "Edycja roli",
            "VIEW": "Dane roli"
          }
        }
      },
      "MODULE": {
        "TITLE": {
          "MODULE_RIGHTS": "Moduł uprawnień"
        },
        "RIGHT": {
          "TITLE": "Uprawnienia",
          "SELECT": "Wybierz prawa",
          "RIGHTS": "Prawa",
          "CHOSEN": "Wybrane prawa",
          "ROLE": {
            "SELECT": "Wybierz role",
            "ROLE": "Rola",
            "ROLES": "Role",
            "CREATE": "Dodaj rolę",
            "EDIT": "Edycja roli",
            "VIEW": "Dane roli",
            "BASE_DATA": "Dane podstawowe",
            "RIGHTS_COUNT": "Ilość praw",
            "INTEND_FOR": "Przeznaczone dla",
            "AVAILABLE": "Dostępne role",
            "ASSIGNED": "Przypisane role",
            "RIGHT": "Prawa",
            "USER_TYPE": "Typ użytkownika"
          },
          "RIGHT": {
            "USERS_MODULE_ACCESS": "Dostęp do modułu użytkowników",
            "USERS_READ": "Odczyt użytkowników",
            "USERS_EDIT": "Edycja użytkowników",
            "RIGHTS_MODULE_ACCESS": "Dostęp do modułu uprawnień",
            "RIGHTS_ROLE_READ": "Odczyt ról",
            "RIGHTS_ROLE_EDIT": "Edycja ról"
          }
        }
      }
    }
  }
});
